<template>
    <a class="general-button" :class="classes" v-if="label && href && isExternal" :href="href" :target="isExternal ? '_blank' : '' ">
        {{ label }}
    </a>
    <router-link v-else-if="label && href && !isExternal"  class="general-button" :to="href" :class="classes">
        {{ label }}
    </router-link>

</template>

<script lang="ts">

import { defineComponent, PropType } from 'vue'



export default defineComponent({

    props: {
        button: {
            type: Object as PropType<{ href: string; label: string; isExternal: boolean; }>,
            required: true
        },
        classes: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const { href, label, isExternal } = props.button;
        const classes = props.classes;
        return {
            href,
            label,
            isExternal,
            classes,
            // arrowRight
        }
    }
})
</script>
